/**
 * 表單的狀態是在檢視還是修改狀態。
 */
export enum FormStatus {
  VIEW = 'view',
  EDIT = 'edit'
}
